export default __webpack_public_path__ + "static/media/dreaming-white.96ace77e.svg";